import { render, staticRenderFns } from "./ColorSelectorSibiling.vue?vue&type=template&id=09d919dc&"
import script from "./ColorSelectorSibiling.vue?vue&type=script&lang=js&"
export * from "./ColorSelectorSibiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports